interface SpaceProps {
  additionalContainerStyle?: any;
  children?: any;
  direction?: string;
  justify?: string;
  size: number;
}

const Space = ({
  additionalContainerStyle = {},
  children,
  direction = 'vertical',
  justify = 'start',
  size,
}: SpaceProps) => {
  let containerStyle;
  let componentStyle;

  if (direction === 'vertical') {
    containerStyle = {};

    componentStyle = {
      marginBottom: size,
    };
  } else {
    containerStyle = {
      display: 'flex',
      justifyContent: justify,
    };

    componentStyle = {
      marginRight: size,
    };
  }

  return (
    <div
      style={{
        ...containerStyle,
        ...additionalContainerStyle,
      }}
    >
      {children.map((child: any, index: number) => {
        const isLast = index === children.length - 1;

        return (
          <div key={index} style={!isLast ? componentStyle : {}}>
            {child}
          </div>
        );
      })}
    </div>
  );
};

export default Space;
